module.exports = __webpack_public_path__ + "media/newstyle/images/word-message-aus-1eac9b0c8d03e6a9ab76c5c79b0d11ad.svg";